import { BasketService } from './../../services/basket.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BasketTotalsService } from 'src/app/services/basket-totals.service';
import { ToolsService } from 'src/app/services/tools.service';
import { TrybeService } from 'src/app/services/trybe.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-treatment',
    templateUrl: './treatment.component.html',
    styleUrls: ['./treatment.component.css']
})
export class TreatmentComponent implements OnInit {

    basket;
    basket$ = this.store.select<any>('basket');

    trybeBasket;
    latestChangeTime = new Date().getTime();
    itemIdx = 0;
    offeringId = '';
    offeringType = '';
    treatmentAdded = false;

    offering;
    item;

    dates = [];
    haveAvailability = false;
    avLoaded = false;
    guestCount = 1;
    guests = [{ name: '', appointment: undefined, active: false, }];
    allocatingAppointment = false;
    dateFrom = '';

    upSell = [];
    crossSell = [];

    constructor(
        private tryBeService: TrybeService,
        private route: ActivatedRoute,
        private router: Router,
        private store: Store,
        private toolsService: ToolsService,
        private basketService: BasketService,
        private basketTotalsService: BasketTotalsService,
    ) { }

    ngOnInit(): void {
        this.itemIdx = this.route.snapshot.params.idx;

        this.basket = this.store.selectForLocal('basket');
        this.item = this.basket.items[this.itemIdx];


        this.itemIdx = this.route.snapshot.params.idx;
        this.offeringId = this.route.snapshot.params.offeringId;
        this.offeringType = this.route.snapshot.params.offeringType;
        this.getOffering();
        this.getTrybeBasket();

    }

    backToTreatments() {
        this.router.navigate(['/bookings/create', 'spa', this.itemIdx])
    }
    getTrybeBasket() {
        if (!this.item.spa) {
            this.item.spa = {}
            this.basketCreate();
        } else {
            if (!this.item.spa.trybeBasket) {
                this.basketCreate();
            } else {
                this.basketGet();
            }
        }
    }

    basketGet() {
        this.tryBeService.basketGet(this.item.spa.trybeBasket.id).subscribe(data => {
            this.item.spa.trybeBasket = data.data.data;
            this.basket.items[this.itemIdx] = this.item;
            this.basketService.saveBasket(this.basket)
        })
    }

    basketCreate() {
        this.tryBeService.basketCreate().subscribe(data => {
            this.item.spa.trybeBasket = data.data.data;
            this.basket.items[this.itemIdx] = this.item;
            this.basketService.saveBasket(this.basket)
        })
    }


    getOffering() {
        this.tryBeService.getOffering(this.offeringType, this.offeringId).subscribe(data => {
            this.offering = data.data.data;
            this.buildDates();
            this.getItemAvailability();
            this.getUpSell();
            this.getCrossSell();
            if (this.offering.min_guests > 1) {
                this.increment()
            }
        })
    }

    getUpSell() {
        this.tryBeService.getOfferingUpSell(this.offeringType, this.offeringId).subscribe(data => {
            this.upSell = data.data.data;
        })
    }

    getCrossSell() {
        this.tryBeService.getOfferingCrossSell(this.offeringType, this.offeringId).subscribe(data => {
            this.crossSell = data.data.data;
        })
    }

    buildDates() {
        for (let i = 0; i <= this.item.availabilitySearch.nights; i++) {
            const date = this.toolsService.dateFromEpochDay(this.item.availabilitySearch.checkInDay + i);

            this.dates.push({
                date,
                dateString: this.toolsService.buildDateString(date),
                epoch: i,
                selected: false,
                hasAvailability: false,
                times: []
            })
        }
        this.selectDate(0);
    }

    selectDate(idx) {
        for (let i = 0; i < this.dates.length; i++) {
            this.dates[i].selected = false;
            if (i === idx) {
                this.dates[i].selected = true;
                this.dateFrom = this.dates[i].dateString;
                this.getTimeSlots(this.dates[i].dateString)
            }
        }
    }

    getTimeSlots(dateFrom) {
        if (this.offering.type === 'package') {
            // this.tryBeService.getPackageTimeSlots(this.offering.type, this.offering.id, dateFrom).subscribe(data => {
            //     data.data.data.forEach((e, idx) => {
            //     });
            //     this.avLoaded = true;
            // })

        } else {
            this.tryBeService.getTimeSlots(this.offering.type, this.offering.id, dateFrom).subscribe(data => {
                data.data.data.forEach((e, idx) => {
                });
                this.avLoaded = true;
            })

        }
    }
    getItemAvailability() {

        this.tryBeService.getItemAvailability(this.offering.type, this.offering.id, this.dates[0].dateString, this.dates[this.dates.length - 1].dateString, this.item.availabilitySearch.adults).subscribe(data => {
            data.data.data.forEach((e, idx) => {
                this.dates[idx].hasAvailability = e.has_availability;
                if (e.has_availability) {
                    this.haveAvailability = true;
                }
            });
            this.avLoaded = true;
        })
    }

    increment() {
        if (+this.guestCount < +this.item.availabilitySearch.adults) {
            this.guestCount = +this.guestCount + 1;
            this.guests.push({ name: '', appointment: undefined, active: false, })
        }
    }

    decrement() {
        if (+this.guestCount > 1) {
            this.guestCount = +this.guestCount - 1;
            this.guests.splice(1);
        }
    }
    allGuestsHaveNames() {

        for (let i = 0; i < this.guests.length; i++) {
            if (!this.guests[i].name) {
                return false;
            }
        }
        return true;
    }

    selectAppointment() {
        this.allocatingAppointment = true;
    }

    appointmentsSelected(e) {
        if (e.action) {
            this.latestChangeTime = new Date().getTime();

            this.basket.items[this.itemIdx].spa.trybeBasket = e.basketItem.spa.trybeBasket;
            this.basket.items[this.itemIdx].checkoutTotals = this.basketTotalsService.calculateItemTotals(this.basket, this.basket.items[this.itemIdx], this.basket.user)
            this.basket = this.basketTotalsService.totalBasket(this.basket);

            this.basketService.saveBasket(this.basket);
            this.treatmentAdded = true;
        }
        this.allocatingAppointment = false;
    }

    viewOffering(offering) {
        this.router.navigate(['bookings/create', 'spa', this.itemIdx, 'treatment', offering.type, offering.id])
    }

    back(e) {
        this.router.navigate(['bookings/create', 'spa', this.itemIdx])
    }
    continue(e) {
        this.router.navigate(['/bookings/create/payment'])
    }
}
